import { smartListConverter as _smartListConverter } from '@griply/services';
import { SmartList } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';
import { NewSmartList } from 'shared/types/smart-list';

export const smartListConverter =
  _smartListConverter as unknown as FirestoreDataConverter<SmartList>;

export const newSmartListConverter = (smartList: NewSmartList) => ({
  ...smartList,
  createdAt: new Date(),
});
